import * as React from 'react';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import { Fonts } from 'source/app/presentation/Shared/Styles/SharedStyles';
import { IGameIdentityDTO } from '../../../../../../../../motw_core/DTOs/IGameIdentityDTO';

export function IdentityType({ identity }: { identity: IGameIdentityDTO }) {
	return (
		<div
			{...Style(`identityType`, {
				...Fonts.iMFell,
				fontSize: `12px`,
				marginBottom: `10px`
			})}
		>
			{identity.iscombo ? 'combo' : 'identity'}
		</div>
	);
}
